export const projects = [

  {
    img: "https://raw.githubusercontent.com/kushagra-01/random/main/Screenshot%20(50).png",
    title: "Tata-1Mg",
    des: "Tata1-Mg is an Indian e-commerce website, which is an e-commerce website of a Medical Products. This is our team collaboration project at Full Stack-development in Masai School.",
    demo: "",
    live: "https://tata1mg.netlify.app/",
    gitHub: "https://github.com/rohan688/tata-Mg1-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB",
      "Mongoose",
      "ExpressJS",
      "NodeJs",
    ],
  },


  {
    img: "https://raw.githubusercontent.com/kushagra-01/random/main/Screenshot%20(49).png",
    title: "Croma-Clone",
    des: "This is the clone of www.Croma.com  for purchasing latest Technology. We cloned only the frontend as well as backend part of the Swiggy.com website with all major functionalities. We have tried to make the same site with our effects and technolgy stacks.",
    demo: "",
    live: "https://dazzling-ardinghelli-bb8d54.netlify.app/",
    gitHub: "https://github.com/MadhanM282/croma1",
    technologies: ["HTML", "CSS", "javaScript"],
  },
  {
    img: "https://raw.githubusercontent.com/kushagra-01/random/main/Screenshot%20(68).png",
    title: "Swiggy-Clone",
    des: "Swiggy is an Indian online food ordering and delivery platform. This is our team collaboration project at Full Stack-development in Masai School.",
    demo: "",
    live: "https://swiggy-kappa.vercel.app/",
    gitHub: "https://github.com/MadhanM282/Swiggy-Clone",
    technologies:[ "HTML",
    "CSS",
    "JavaScript",
    "MongoDB",
    "Mongoose",
    "ExpressJS",
    "NodeJs",
  "React",
"Redux"],
  }
]